import { Component, AfterContentInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFileAlt, faCamera, faChartColumn } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

interface ParallaxOptions {
  relativeInput?: boolean;
  hoverOnly?: boolean;
}

declare class Parallax {
  constructor(element: HTMLElement | null, options?: ParallaxOptions);
}
@Component({
  selector: 'app-home-section-movil',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './home-section-movil.component.html',
  styleUrls: ['./home-section-movil.component.scss'],
})
export class HomeSectionMovilComponent implements AfterContentInit {
  public titleKey = 'home.mobile.title';
  public subtitleKey = 'home.mobile.subtitle';
  public items = [
    {
      icon: faFileAlt,
      titleKey: 'home.mobile.items.deliveryStatus.title',
      textKey: 'home.mobile.items.deliveryStatus.text',
    },
    {
      icon: faCamera,
      titleKey: 'home.mobile.items.scanPackages.title',
      textKey: 'home.mobile.items.scanPackages.text',
    },
    {
      icon: faChartColumn,
      titleKey: 'home.mobile.items.dashboard.title',
      textKey: 'home.mobile.items.dashboard.text',
    },
  ];

  ngAfterContentInit() {
    const scene3 = document.getElementById('scene3');
    new Parallax(scene3, {
      relativeInput: true,
      hoverOnly: true,
    });

    const scene3phone = document.getElementById('scene3phone');
    new Parallax(scene3phone, {
      relativeInput: true,
      hoverOnly: true,
    });
  }
}
